document.addEventListener('DOMContentLoaded', function() {

  // CURSEUR
  const cur = document.getElementById('cur'), ring = document.getElementById('ring');
  let mx = 0, my = 0, rx = 0, ry = 0;
  if (cur && ring) {
    document.addEventListener('mousemove', e => { mx = e.clientX; my = e.clientY; cur.style.left = mx+'px'; cur.style.top = my+'px'; });
    function animRing(){ rx += (mx-rx)*.12; ry += (my-ry)*.12; ring.style.left = rx+'px'; ring.style.top = ry+'px'; requestAnimationFrame(animRing); } animRing();
    document.querySelectorAll('a,button,.pcard,.scard').forEach(el => {
      el.addEventListener('mouseenter', () => { cur.classList.add('hv'); ring.classList.add('hv'); });
      el.addEventListener('mouseleave', () => { cur.classList.remove('hv'); ring.classList.remove('hv'); });
    });
  }

  // NAV SCROLL
  const nav = document.getElementById('nav');
  if (nav) window.addEventListener('scroll', () => nav.classList.toggle('sc', scrollY > 60));

  // FILTRE ACTIF
  const path = window.location.pathname;
  document.querySelectorAll('.fb').forEach(btn => {
    if (btn.getAttribute('href') === path) { document.querySelectorAll('.fb').forEach(b => b.classList.remove('on')); btn.classList.add('on'); }
  });

  // GALERIE PRODUIT
  document.querySelectorAll('.pp-thumb').forEach(t => {
    t.addEventListener('click', () => { document.querySelectorAll('.pp-thumb').forEach(x => x.classList.remove('active')); t.classList.add('active'); });
  });

});

// AJOUTER AU PANIER AJAX
window.addToCart = function(variantId, btn) {
  const orig = btn ? btn.textContent : '';
  if (btn) { btn.textContent = '...'; btn.disabled = true; }
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(r => r.json())
  .then(data => {
    showToast('✓ ' + data.title + ' ajouté !');
    return fetch('/cart.js');
  })
  .then(r => r.json())
  .then(cart => {
    const cn = document.querySelector('.cn');
    if (cn) cn.textContent = cart.item_count;
    if (btn) { btn.textContent = '✓'; setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 2000); }
  })
  .catch(() => { if (btn) { btn.textContent = orig; btn.disabled = false; } });
};

// TOAST
let tt;
window.showToast = function(msg) {
  const t = document.getElementById('toast');
  if (!t) return;
  t.textContent = msg; t.classList.add('on');
  clearTimeout(tt); tt = setTimeout(() => t.classList.remove('on'), 2800);
};
